import { Component, Element, h, Host, Method, Prop, Watch } from '@stencil/core'
import BpmnViewer from 'bpmn-js/lib/NavigatedViewer'
import taskCountHeatmap from './overlays/task-count-heatmaps'
import taskCountBubble from './overlays/task-count-bubbles'

@Component({
  tag: 'cr-bpmn',
  styleUrl: 'cr-bpmn.css',
  shadow: true,
})
export class CrBpmn {

  @Element() host!: HTMLElement

  @Prop() xml: string = ""
  @Prop() overlayinfo: any = {}
  @Prop() layers: Array<string> = []

  @Method()
  async getCanvasElement(): Promise<any> {
    return this.canvas
  }

  @Watch('xml')
  async watchProcessDefinition() {
    this.resetCanvas()
    await this.loadProcessDefinition()
  }

  @Watch('overlayinfo')
  async generateOverlays() {
    if (this.overlayinfo.hasOwnProperty("taskdata")) {
      (this.canvas.get('overlays') as any).clear()
      if (this.layers.includes('heatmap')) {
        taskCountHeatmap(this.canvas, this.overlayinfo)
      }
      if (this.layers.includes('bubbles')) {
        taskCountBubble(this.canvas, this.overlayinfo)
      }
    }
  }

  async componentDidRender() {
    this.resetCanvas()
    await this.loadProcessDefinition()
  }

  render() {
    return (
      <Host><div class="workflow-canvas" ref={(el) => this.workflowCanvas = el as HTMLElement}></div></Host>
    );
  }

  private resetCanvas() {
    while (this.workflowCanvas.firstChild) {
      this.workflowCanvas.removeChild(this.workflowCanvas.firstChild)
    }
    try {
      this.canvas = new BpmnViewer({
        container: this.workflowCanvas
      })
    } catch (err) {
      console.error(err)
    }
  }

  private async loadProcessDefinition() {
    if (this.xml) {
      try {
        await this.canvas.importXML(this.xml)
        this.generateOverlays()
      } catch(e) {
        console.error(e)
      }
    }
  }

  private canvas: BpmnViewer
  private workflowCanvas!: HTMLElement

}
